export default __webpack_public_path__ + "static/media/black-logo-icon.eca2ecbf.svg";